import React, { useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper';
import { PageWidthContainer } from '@vio/atlas/helpers/PageWidthContainer';
import { Text } from '@vio/atlas/Text';
import { getLanguageCode } from 'modules/meta/selectors';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { HighlightedTitle } from '../HighlightedTitle';
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "cv0d54f",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => ContentWrapper;
const SectionWrapper = /*#__PURE__*/styled(_exp5())({
  name: "SectionWrapper",
  class: "s1rmwm4h",
  propsAsIs: true
});
const _exp12 = /*#__PURE__*/() => Text;
const Title = /*#__PURE__*/styled(_exp12())({
  name: "Title",
  class: "ttdaqvf",
  propsAsIs: true
});
const _exp16 = /*#__PURE__*/() => Text;
const Subtitle = /*#__PURE__*/styled(_exp16())({
  name: "Subtitle",
  class: "s2npnai",
  propsAsIs: true
});
const BasePowerFeaturesWrapper = /*#__PURE__*/styled('div')({
  name: "BasePowerFeaturesWrapper",
  class: "b191dsoe",
  propsAsIs: false
});
const _exp21 = /*#__PURE__*/() => BasePowerFeaturesWrapper;
const TopPowerFeaturesWrapper = /*#__PURE__*/styled(_exp21())({
  name: "TopPowerFeaturesWrapper",
  class: "tjlpli4",
  propsAsIs: true
});
const _exp23 = /*#__PURE__*/() => BasePowerFeaturesWrapper;
const PowerFeaturesWrapper = /*#__PURE__*/styled(_exp23())({
  name: "PowerFeaturesWrapper",
  class: "pzhwxvq",
  propsAsIs: true
});
const Feature = /*#__PURE__*/styled('div')({
  name: "Feature",
  class: "f1t9ypph",
  propsAsIs: false
});
const _exp30 = /*#__PURE__*/() => ({
  src
}) => `url(${src})`;
const FeatureImage = /*#__PURE__*/styled('div')({
  name: "FeatureImage",
  class: "f9hku8c",
  propsAsIs: false,
  vars: {
    "f9hku8c-0": [_exp30()]
  }
});
const features = defineMessages({
  reservePriceForFreeBookWhenYourReady: {
    id: 'homePage.powerFeaturesReservePriceForFreeBookWhenYourReady',
    defaultMessage: 'Reserve a price for free,<br></br>book when you’re ready'
  },
  combineRoomsToFindHiddenSavings: {
    id: 'homePage.powerFeaturesCombineRoomsToFindHiddenSavings',
    defaultMessage: 'Combine rooms to find<br></br>hidden savings and availability'
  },
  bookNowChooseWhenToPay: {
    id: 'homePage.powerFeaturesBookNowChooseWhenToPay',
    defaultMessage: 'Book now,<br></br>choose when to pay'
  },
  trackPricesAtYourFavouriteHotel: {
    id: 'homePage.trackPricesAtYourFavouriteHotel',
    defaultMessage: 'Track prices at your<br></br>favourite hotels'
  },
  comparePricesInCalendar: {
    id: 'homePage.powerFeaturesComparePricesInCalendar',
    defaultMessage: 'Compare prices<br></br>in the calendar'
  }
});
export const PowerFeaturesSection = () => {
  const {
    isMobile
  } = useDeviceLayout();
  const {
    formatMessage
  } = useIntl();
  const languageCode = useSelector(getLanguageCode);
  const {
    current: powerFeaturesItems
  } = useRef([{
    title: features.reservePriceForFreeBookWhenYourReady,
    image: `HomePage/${languageCode}/deal-freeze.webp`
  }, {
    title: features.combineRoomsToFindHiddenSavings,
    image: `HomePage/${languageCode}/split-booking-mobile.webp`
  }, {
    title: features.bookNowChooseWhenToPay,
    image: `HomePage/${languageCode}/pay-later.webp`
  }, {
    title: features.trackPricesAtYourFavouriteHotel,
    image: `HomePage/${languageCode}/price-track.webp`
  }, {
    title: features.comparePricesInCalendar,
    image: `HomePage/${languageCode}/price-calendar.webp`
  }]);
  return <Container>
      <PageWidthContainer>
        <SectionWrapper paddingX={isMobile ? 's600' : 's950'} paddingY={'s800'}>
          <Title align="center" variant={isMobile ? 'title2XL' : 'title4XL'}>
            <HighlightedTitle source="NeverMissOut" />
          </Title>
          <Subtitle align="center" variant="bodyL">
            <FormattedMessageWrapper id="homePage.powerFeaturesSubtitle" defaultMessage="Our powerful features help you book the best place at the best
            price, every time." />
          </Subtitle>

          <TopPowerFeaturesWrapper>
            {powerFeaturesItems.slice(0, 2).map(({
            title,
            image
          }) => <Feature key={JSON.stringify(title)}>
                <Text align="center" variant="titleL">
                  {formatMessage(title, {
                br: () => <br />
              })}
                </Text>
                <FeatureImage className="image" src={`${process.env.NEXT_PUBLIC_STATIC_ASSETS_ENDPOINT}${image}`} />
              </Feature>)}
          </TopPowerFeaturesWrapper>

          <PowerFeaturesWrapper>
            {powerFeaturesItems.slice(2).map(({
            title,
            image
          }) => <Feature key={JSON.stringify(title)}>
                <Text align="center" variant="titleL">
                  {formatMessage(title, {
                br: () => <br />
              })}
                </Text>
                <FeatureImage className="image" src={`${process.env.NEXT_PUBLIC_STATIC_ASSETS_ENDPOINT}${image}`} />
              </Feature>)}
          </PowerFeaturesWrapper>
        </SectionWrapper>
      </PageWidthContainer>
    </Container>;
};

require("./PowerFeaturesSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PowerFeaturesSection.tsx");